(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-filters')) {
    customElements.define('cf-filters', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.auto = this.dataset.auto === 'true';
        this.form = this.querySelector('.cf__form');

        // Gruppen auf-/zuklappen (bei accordion/bar/drawer)
        this.querySelectorAll('.cf__grouptitle').forEach(function (t) {
          t.addEventListener('click', function () {
            var grp = t.closest('.cf__group');
            if (grp) grp.classList.toggle('is-open');
          });
        });

        // Drawer öffnen/schließen
        this.querySelectorAll('[data-cf-open]').forEach(function (b) { b.addEventListener('click', function () { self.classList.add('is-open'); }); });
        this.querySelectorAll('[data-cf-close]').forEach(function (b) { b.addEventListener('click', function () { self.classList.remove('is-open'); }); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.classList.remove('is-open'); });

        // Checkboxen
        this.querySelectorAll('.cf__value input[type=checkbox]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            var lab = cb.closest('.cf__value'); if (lab) lab.classList.toggle('is-active', cb.checked);
            if (self.auto) self.submit();
          });
        });

        // Preis-Slider
        this.querySelectorAll('.cf__price').forEach(function (p) { self.initPrice(p); });
      }

      submit() { if (this.form) this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit(); }

      initPrice(p) {
        var self = this;
        var min = p.querySelector('.cf__r--min');
        var max = p.querySelector('.cf__r--max');
        var fill = p.querySelector('.cf__price-fill');
        var lo = p.querySelector('.cf__price-lo');
        var hi = p.querySelector('.cf__price-hi');
        var rmax = parseFloat(p.dataset.rmax) || 100;
        function paint() {
          var a = Math.min(+min.value, +max.value);
          var b = Math.max(+min.value, +max.value);
          fill.style.left = (a / rmax * 100) + '%';
          fill.style.width = ((b - a) / rmax * 100) + '%';
          lo.textContent = a; hi.textContent = b;
        }
        function clamp(e) {
          if (+min.value > +max.value) {
            if (e.target === min) min.value = max.value; else max.value = min.value;
          }
          paint();
        }
        min.addEventListener('input', clamp);
        max.addEventListener('input', clamp);
        if (this.auto) {
          min.addEventListener('change', function () { self.submit(); });
          max.addEventListener('change', function () { self.submit(); });
        }
        paint();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-food-pairing"] && !Shopify.designMode) return;
  try {
    
  if (!window.__fpBundleInit) {
    window.__fpBundleInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fp-add]');
      if (!btn) return;
      e.preventDefault();
      var ids = (btn.dataset.fpAdd || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
      btn.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        var n = document.querySelector('cart-notification, cart-drawer');
        if (n && typeof n.open === 'function') { n.open(); }
        btn.classList.add('is-success');
        var t = btn.textContent; btn.textContent = '✓ Hinzugefügt';
        setTimeout(function () { btn.classList.remove('is-success'); btn.textContent = t; btn.disabled = false; }, 1600);
      }).catch(function () { btn.disabled = false; alert('Konnte nicht hinzugefügt werden.'); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsFooter) return;
  window.__pjsFooter = true;

  // Menü-Spalten auf dem Handy einklappen. Auf dem Desktop bleiben sie offen,
  // damit ohne JavaScript nichts versteckt ist (die Spalten sind dort ohnehin nebeneinander).
  var MQ = '(max-width: 749px)';

  function apply(root) {
    var an = root.classList && root.classList.contains('ft--akkordeon');
    if (!an) return;
    var klein = false;
    try { klein = window.matchMedia(MQ).matches; } catch (e) {}
    root.querySelectorAll('[data-ft-akkordeon]').forEach(function (d) {
      // Was der Besucher selbst geöffnet hat, bleibt offen
      if (d.dataset.ftTouched === '1') return;
      d.open = !klein;
    });
  }

  function wire(root) {
    if (root.dataset.ftWired) return;
    root.dataset.ftWired = '1';
    root.querySelectorAll('[data-ft-akkordeon]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        try { if (window.matchMedia(MQ).matches) d.dataset.ftTouched = '1'; } catch (e) {}
      });
    });
    apply(root);
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        root.querySelectorAll('[data-ft-akkordeon]').forEach(function (d) { d.dataset.ftTouched = '0'; });
        apply(root);
      }, 150);
    });
  }

  function run(scope) {
    var r = (scope && scope.querySelectorAll) ? scope : document;
    r.querySelectorAll('[data-ft-root]').forEach(wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chb-carousel')) {
    customElements.define('chb-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.chb__slide'));
        this.dots = Array.from(this.querySelectorAll('.chb__dot'));
        this.index = 0;
        this.interval = (parseFloat(this.dataset.interval) || 0) * 1000;
        var prev = this.querySelector('.chb__nav--prev');
        var next = this.querySelector('.chb__nav--next');
        var self = this;
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });
        this.dots.forEach(function (dot, i) { dot.addEventListener('click', function () { self.go(i, true); }); });
        if (this.slides.length > 1 && this.interval > 0) {
          this.start();
          this.addEventListener('mouseenter', function () { self.stop(); });
          this.addEventListener('mouseleave', function () { self.start(); });
        }
      }
      go(i, manual) {
        var n = this.slides.length;
        if (n <= 1) return;
        this.slides[this.index].classList.remove('is-active');
        if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
        this.index = ((i % n) + n) % n;
        this.slides[this.index].classList.add('is-active');
        if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
        if (manual) this.start();
      }
      start() { var self = this; this.stop(); if (this.interval > 0 && this.slides.length > 1) this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval); }
      stop() { if (this.timer) clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    });
  }

  if (!customElements.get('chb-mosaic')) {
    customElements.define('chb-mosaic', class extends HTMLElement {
      connectedCallback() {
        var sec = parseFloat(this.dataset.mobileAutoplay) || 0;
        if (sec <= 0) return;
        var self = this;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.tick = function () {
          if (!self.mq.matches) return;
          var w = self.clientWidth;
          if (self.scrollLeft + w >= self.scrollWidth - 5) { self.scrollTo({ left: 0, behavior: 'smooth' }); }
          else { self.scrollBy({ left: w, behavior: 'smooth' }); }
        };
        this.startAuto = function () { self.stopAuto(); self.timer = setInterval(self.tick, sec * 1000); };
        this.stopAuto = function () { if (self.timer) { clearInterval(self.timer); self.timer = null; } };
        ['pointerdown', 'mouseenter'].forEach(function (e) { self.addEventListener(e, function () { self.stopAuto(); }); });
        ['pointerup', 'mouseleave'].forEach(function (e) { self.addEventListener(e, function () { self.startAuto(); }); });
        this.startAuto();
      }
      disconnectedCallback() { if (this.stopAuto) this.stopAuto(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsHero) return;
  window.__pjsHero = true;

  function init(main) {
    if (main.dataset.hxWired) return;
    main.dataset.hxWired = '1';

    var slides = Array.prototype.slice.call(main.querySelectorAll('[data-hx-slide]'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(main.querySelectorAll('[data-hx-dot]'));
    var timer = null;
    var i = 0;
    var interval = parseInt(main.dataset.interval || '5000', 10);
    var auto = main.dataset.auto === '1' && slides.length > 1;
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    function show(n) {
      i = (n % slides.length + slides.length) % slides.length;
      slides.forEach(function (el, k) {
        var on = k === i;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        // Ausgeblendete Slides aus der Tabreihenfolge nehmen
        el.querySelectorAll('a, button').forEach(function (f) {
          if (on) f.removeAttribute('tabindex'); else f.setAttribute('tabindex', '-1');
        });
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function arm() { stop(); if (auto && !reduce) timer = setInterval(function () { show(i + 1); }, interval); }

    main.__hxShow = function (n) { show(n); arm(); };
    main.__hxStop = stop;

    main.querySelectorAll('[data-hx-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); arm(); });
    });
    main.querySelectorAll('[data-hx-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); arm(); });
    });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); arm(); }); });

    if (main.dataset.pause === '1') {
      main.addEventListener('mouseenter', stop);
      main.addEventListener('mouseleave', arm);
      main.addEventListener('focusin', stop);
      main.addEventListener('focusout', arm);
    }
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(i - 1); arm(); }
      else if (e.key === 'ArrowRight') { show(i + 1); arm(); }
    });
    // Wischen auf dem Handy
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { show(dx < 0 ? i + 1 : i - 1); arm(); }
      x0 = null; y0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else arm(); });

    show(0);
    arm();
  }

  function run(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-hx-main]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });

  // Im Theme-Editor: gewähltes Großbild anzeigen und den Wechsel anhalten
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    var slide = (el.matches && el.matches('[data-hx-slide]')) ? el : el.querySelector('[data-hx-slide]');
    if (!slide) return;
    var main = slide.closest('[data-hx-main]');
    if (!main || !main.__hxShow) return;
    var all = Array.prototype.slice.call(main.querySelectorAll('[data-hx-slide]'));
    main.__hxShow(all.indexOf(slide));
    if (main.__hxStop) main.__hxStop();
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var main = el.closest('[data-hx-main]');
    if (main && main.__hxShow) main.__hxShow(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-info-spalten"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsAllergenHL) return;
  window.__pjsAllergenHL = true;

  function buildPattern(terms) {
    var parts = [];
    terms.forEach(function (raw) {
      var t = (raw || '').trim();
      if (!t) return;
      var p = '';
      for (var i = 0; i < t.length; i++) {
        var c = t[i], lc = c.toLowerCase();
        if (lc === 'ä') p += '[äa]';
        else if (lc === 'ö') p += '[öo]';
        else if (lc === 'ü') p += '[üu]';
        else if (lc === 'ß') p += '(?:ß|ss)';
        else p += c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      if (p) parts.push(p);
    });
    if (!parts.length) return null;
    parts.sort(function (a, b) { return b.length - a.length; });
    return new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + parts.join('|') + ')', 'gi');
  }

  function highlight(el, re) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.parentNode && n.parentNode.tagName !== 'STRONG') nodes.push(n);
    }
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(txt)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        var ts = m.index + (m[1] ? m[1].length : 0);
        if (ts > last) frag.appendChild(document.createTextNode(txt.slice(last, ts)));
        var s = document.createElement('strong');
        s.className = 'nw__al';
        s.textContent = m[2].toUpperCase();
        frag.appendChild(s);
        last = ts + m[2].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() {
    document.querySelectorAll('[data-nw-zutaten]').forEach(function (el) {
      if (el.dataset.nwDone) return;
      var re = buildPattern((el.getAttribute('data-allergens') || '').split(','));
      if (!re) { el.dataset.nwDone = '1'; return; }
      try { highlight(el, re); } catch (e) {}
      el.dataset.nwDone = '1';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-katalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__katInit) return; window.__katInit = true;
  var root = function (el) { return el && el.closest ? el.closest('[data-kat]') : null; };
  var withSection = function (url, sid) { var u = new URL(url, location.origin); u.searchParams.set('section_id', sid); return u.toString(); };
  var clean = function (url) { var u = new URL(url, location.origin); u.searchParams.delete('section_id'); return u.pathname + u.search; };
  var shopRoot = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  // Filter, Pills im Panel, Zurücksetzen und Sortierung: nur diese Section neu laden
  function load(r, url, push) {
    if (!r) { location.href = url; return; }
    var mf = r.classList.contains('is-mf');
    r.classList.add('is-loading');
    fetch(withSection(url, r.dataset.section), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-kat]');
        if (!nr) { location.href = url; return; }
        if (mf) {
          nr.classList.add('is-mf');
          nr.querySelectorAll('.kat-mf-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        }
        r.replaceWith(nr);
        if (push) history.pushState({ kat: 1 }, '', clean(url));
      })
      .catch(function () { location.href = url; });
  }

  function loadMore(r, btn) {
    btn.classList.add('is-busy');
    fetch(withSection(btn.href, r.dataset.section), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = r.querySelector('[data-kat-grid]'), ng = doc.querySelector('[data-kat-grid]');
        if (grid && ng) Array.prototype.slice.call(ng.children).forEach(function (c) { grid.appendChild(c); });
        var w = r.querySelector('[data-kat-morewrap]'), nw = doc.querySelector('[data-kat-morewrap]');
        if (w && nw) w.replaceWith(nw); else if (w) w.remove();
      })
      .catch(function () { location.href = btn.href; });
  }

  // In den Warenkorb: Horizon-Standardereignis auslösen, damit Warenkorb-Symbol und -Schublade mitziehen
  function addToCart(btn) {
    var card = btn.closest('[data-kat-card]');
    var qEl = card && card.querySelector('[data-kat-q]');
    var step = parseInt((card && card.dataset.step) || '1', 10) || 1;
    var q = parseInt(qEl ? qEl.textContent : step, 10) || step;
    var err = card && card.querySelector('[data-kat-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.disabled = true; btn.classList.add('is-busy');
    var resolve, reject, promise = new Promise(function (a, b) { resolve = a; reject = b; });
    var events = null;
    import('@shopify/events').then(function (m) {
      if (m && m.CartLinesUpdateEvent) {
        events = m;
        btn.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(btn.dataset.variant), quantity: q }], promise: promise }));
      }
    }).catch(function () {}).then(function () {
      return fetch(shopRoot() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: q }] })
      });
    }).then(function (res) {
      return res.json().then(function (j) { return { ok: res.ok && !j.status, j: j }; });
    }).then(function (out) {
      return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (events) resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'katalog', itemCount: q, items: cart.items, didError: !out.ok } });
        if (out.ok) {
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        } else if (err) {
          err.textContent = out.j.description || out.j.message || 'Konnte nicht in den Warenkorb gelegt werden.';
          err.hidden = false;
        }
      });
    }).catch(function (e) {
      if (events) reject(e);
      if (err) { err.textContent = 'Konnte nicht in den Warenkorb gelegt werden.'; err.hidden = false; }
    }).then(function () {
      btn.disabled = false; btn.classList.remove('is-busy');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t.closest && t.closest('[data-kat] a[data-kat-link]');
    if (a) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault(); load(root(a), a.href, true); return;
    }
    var more = t.closest && t.closest('[data-kat] [data-kat-more]');
    if (more) { e.preventDefault(); loadMore(root(more), more); return; }
    var mf = t.closest && t.closest('[data-kat] [data-kat-mf]');
    if (mf) {
      var r = root(mf), open = !r.classList.contains('is-mf');
      r.classList.toggle('is-mf', open);
      r.querySelectorAll('.kat-mf-btn').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (!open) { var g = r.querySelector('.kat-res'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    var qb = t.closest && t.closest('[data-kat] [data-kat-dec], [data-kat] [data-kat-inc]');
    if (qb) {
      var c = qb.closest('[data-kat-card]'), sp = c.querySelector('[data-kat-q]');
      var st = parseInt(c.dataset.step || '1', 10) || 1, qv = parseInt(sp.textContent, 10) || st;
      qv = qb.hasAttribute('data-kat-inc') ? qv + st : Math.max(st, qv - st);
      sp.textContent = qv; return;
    }
    var add = t.closest && t.closest('[data-kat] [data-kat-add]');
    if (add && !add.disabled) { e.preventDefault(); addToCart(add); }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-kat] select[data-kat-sort]');
    if (!sel) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
    load(root(sel), u.toString(), true);
  });
  window.addEventListener('popstate', function () {
    var r = document.querySelector('[data-kat]');
    if (r) load(r, location.href, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-kategorie-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ktInit) return; window.__ktInit = true;
  function measure(body) {
    if (!body.classList.contains('is-clamp') || body.classList.contains('is-open')) return;
    var rte = body.querySelector('.kt-rte');
    body.classList.toggle('has-more', !!rte && rte.scrollHeight > rte.clientHeight + 4);
  }
  function run(scope) { (scope || document).querySelectorAll('[data-kt-body]').forEach(measure); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kt-more]');
    if (!b) return;
    var body = b.parentElement.querySelector('[data-kt-body]');
    if (!body) return;
    var open = !body.classList.contains('is-open');
    body.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) { measure(body); body.closest('[data-kt]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { run(); }, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  window.addEventListener('load', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-kollektion-kopf"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__kkInit) return; window.__kkInit = true;
  function show(gal, i) {
    var imgs = gal.querySelectorAll('.kk-img');
    if (!imgs.length) return;
    var n = imgs.length; i = (i + n) % n;
    imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
    gal.querySelectorAll('[data-kk-thumb]').forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    var c = gal.querySelector('[data-kk-count]'); if (c) c.textContent = (i + 1) + ' / ' + n;
    gal.dataset.cur = i;
  }
  function measure(el) {
    if (el.classList.contains('is-open')) return;
    el.classList.add('is-clamp');
    el.classList.toggle('has-more', el.scrollHeight > el.clientHeight + 2);
  }
  function run(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-kk-gal]').forEach(function (g) { if (!g.querySelector('.kk-img.is-on')) show(g, 0); });
    root.querySelectorAll('[data-kk-intro]').forEach(measure);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = t.closest && t.closest('[data-kk-prev], [data-kk-next], [data-kk-thumb]');
    if (nav) {
      var gal = nav.closest('[data-kk-gal]'), cur = parseInt(gal.dataset.cur || '0', 10);
      if (nav.hasAttribute('data-kk-thumb')) show(gal, parseInt(nav.getAttribute('data-kk-thumb'), 10));
      else show(gal, cur + (nav.hasAttribute('data-kk-next') ? 1 : -1));
      return;
    }
    var more = t.closest && t.closest('[data-kk-more]');
    if (more) {
      var intro = more.previousElementSibling;
      if (!intro) return;
      var open = !intro.classList.contains('is-open');
      intro.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) measure(intro);
    }
  });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { document.querySelectorAll('[data-kk-intro]').forEach(measure); }, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-naehrwerte"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pjsNW) return;
  window.__pjsNW = true;

  function frag(t) {
    var p = '';
    for (var i = 0; i < t.length; i++) {
      var c = t[i], lc = c.toLowerCase();
      if (lc === 'ä') p += '[äa]'; else if (lc === 'ö') p += '[öo]';
      else if (lc === 'ü') p += '[üu]'; else if (lc === 'ß') p += '(?:ß|ss)';
      else p += c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    return p;
  }
  function buildPattern(terms) {
    var parts = [];
    terms.forEach(function (raw) { var t = (raw || '').trim(); if (t) parts.push(frag(t)); });
    if (!parts.length) return null;
    parts.sort(function (a, b) { return b.length - a.length; });
    return new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + parts.join('|') + ')', 'gi');
  }
  var GROUPS = [
    { name: 'Glutenhaltiges Getreide', terms: ['gluten','weizen','hartweizen','dinkel','emmer','einkorn','khorasan','kamut','roggen','gerste','hafer','malz','grieß','couscous','bulgur','seitan'] },
    { name: 'Krebstiere', terms: ['krebstier','garnele','krabbe','hummer','languste','scampi','shrimp'] },
    { name: 'Eier', terms: ['eier','eigelb','eiklar','eiweiß','eipulver','vollei'] },
    { name: 'Fisch', terms: ['fisch','lachs','thunfisch','hering','sardelle','anchovis','makrele','forelle','kabeljau'] },
    { name: 'Erdnüsse', terms: ['erdnuss','erdnüsse'] },
    { name: 'Soja', terms: ['soja','sojabohne','sojalecithin','sojaeiweiß','tofu','edamame'] },
    { name: 'Milch/Laktose', terms: ['milch','sahne','rahm','butter','käse','molke','laktose','joghurt','quark','buttermilch','kasein'] },
    { name: 'Schalenfrüchte', terms: ['mandel','marzipan','haselnuss','walnuss','cashew','kaschunuss','pistazie','pekannuss','paranuss','macadamia','nuss','nüsse','nougat','krokant'] },
    { name: 'Sellerie', terms: ['sellerie'] },
    { name: 'Senf', terms: ['senf'] },
    { name: 'Sesam', terms: ['sesam','tahin'] },
    { name: 'Sulfite', terms: ['sulfit','schwefeldioxid','schwefel'] },
    { name: 'Lupinen', terms: ['lupine','lupinen'] },
    { name: 'Weichtiere', terms: ['weichtier','muschel','auster','tintenfisch','calamari','schnecke'] }
  ];
  var GROUP_RE = GROUPS.map(function (g) { return { name: g.name, re: new RegExp('(^|[^A-Za-zÄÖÜäöüß])(' + g.terms.map(frag).join('|') + ')', 'i') }; });
  function detect(text, into) { if (!text) return; GROUP_RE.forEach(function (g) { if (g.re.test(text)) into[g.name] = true; }); }

  function highlight(el, re) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.parentNode && n.parentNode.tagName !== 'STRONG') nodes.push(n); }
    nodes.forEach(function (node) {
      var txt = node.nodeValue; re.lastIndex = 0;
      if (!re.test(txt)) return; re.lastIndex = 0;
      var f = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        var ts = m.index + (m[1] ? m[1].length : 0);
        if (ts > last) f.appendChild(document.createTextNode(txt.slice(last, ts)));
        var st = document.createElement('strong'); st.className = 'nw__al'; st.textContent = m[2].toUpperCase();
        f.appendChild(st); last = ts + m[2].length; if (m[0].length === 0) re.lastIndex++;
      }
      if (last < txt.length) f.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(f, node);
    });
  }

  var TEXT_SEL = "[data-nw-role='zutaten'],[data-nw-role='allergene'],[data-nw-role='pflicht'],[data-nw-role='angaben']";
  // Text-Blöcke (Zutaten/Allergene/Pflichtangaben) + Badges (nur wenn NACH der Tabelle) zu EINER Spalte gruppieren.
  function groupText(sec) {
    var grid = sec.querySelector('.nw2__grid'); if (!grid) return;
    // Alte Gruppierung immer auflösen und frisch berechnen (Observer ist während des Laufs abgekoppelt)
    var col = grid.querySelector(':scope > .nw2__textcol');
    if (col) { while (col.firstChild) grid.insertBefore(col.firstChild, col); col.remove(); }
    var children = Array.prototype.slice.call(grid.children);
    var tableIdx = -1;
    for (var i = 0; i < children.length; i++) {
      if (children[i].querySelector && children[i].querySelector("[data-nw-role='tabelle']")) { tableIdx = i; break; }
    }
    var members = children.filter(function (w, idx) {
      if (!w.querySelector) return false;
      if (w.querySelector(TEXT_SEL)) return true;
      // Badges einbeziehen, wenn sie nach der Tabelle stehen (sonst bleiben sie ein volle-Breite-Banner)
      if (w.querySelector("[data-nw-role='badges']") && (tableIdx < 0 || idx > tableIdx)) return true;
      return false;
    });
    if (!members.length) return;
    var nc = document.createElement('div'); nc.className = 'nw2__textcol';
    grid.insertBefore(nc, members[0]);
    members.forEach(function (w) { nc.appendChild(w); });
  }

  // Selbstheilung: Editor-Änderungen (Neu-Render/Umsortieren) neu verarbeiten
  function setupObserver(sec) {
    var grid = sec.querySelector('.nw2__grid');
    if (!grid || grid.__nwObs) return;
    var obs = new MutationObserver(function () {
      obs.disconnect();
      try { process(sec); } catch (e) {}
      if (grid.isConnected) obs.observe(grid, { childList: true });
    });
    grid.__nwObs = obs;
    obs.observe(grid, { childList: true });
  }

  function wireCollap(root) {
    if (root.dataset.collapWired) return; root.dataset.collapWired = '1';
    var btn = root.querySelector('.nw-collap__btn'); if (!btn) return;
    btn.addEventListener('click', function () {
      var closed = root.classList.toggle('nw-collap--closed');
      btn.setAttribute('aria-expanded', String(!closed));
      var lbl = btn.querySelector('.nw-collap__lbl');
      if (lbl) lbl.textContent = closed ? (btn.dataset.more || 'anzeigen') : (btn.dataset.less || 'ausblenden');
    });
  }

  function run(scope) {
    var root = scope || document;
    var list = [];
    if (root.classList && root.classList.contains('section-nwx')) list.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.section-nwx').forEach(function (s) { list.push(s); });
    list.forEach(process);
  }

  function process(sec) {
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      groupText(sec);
      // Auto-Allergene (Zutaten ∪ Metafeld, entdoppelt) — vor dem Highlighten
      sec.querySelectorAll('[data-nw-allergene-auto]').forEach(function (box) {
        var found = {};
        sec.querySelectorAll('[data-nw-ing]').forEach(function (ing) { detect(ing.textContent, found); });
        detect(box.getAttribute('data-nw-mf') || '', found);
        var list = GROUPS.map(function (g) { return g.name; }).filter(function (name) { return found[name]; });
        var wrapEl = box.closest('.shopify-block') || box.closest('.nwtx');
        if (list.length) { box.textContent = list.join(', '); }
        else if (!designMode) { if (wrapEl) wrapEl.style.display = 'none'; }
        else { box.textContent = '(automatisch — erscheint, sobald Zutaten/Metafeld Allergene enthalten)'; }
      });
      // Allergene fett + GROSS in den Zutaten
      sec.querySelectorAll('[data-nw-hl]').forEach(function (el) {
        if (el.dataset.nwDone) return;
        var re = buildPattern((el.getAttribute('data-nw-terms') || '').split(','));
        if (re) { try { highlight(el, re); } catch (e) {} }
        el.dataset.nwDone = '1';
      });
      // Einklapp-Buttons verdrahten
      sec.querySelectorAll('.nw-collap').forEach(wireCollap);
      // Aufklappbare Karte
      var root = sec.querySelector('.nwx');
      var tgl = sec.querySelector('[data-nw-toggle]');
      if (root && tgl && !tgl.dataset.wired) {
        tgl.dataset.wired = '1';
        tgl.addEventListener('click', function () {
          var open = root.dataset.open === '1' ? '0' : '1';
          root.dataset.open = open;
          tgl.setAttribute('aria-expanded', open === '1' ? 'true' : 'false');
        });
        // Über Anker-Links (#pdp-nutri) automatisch öffnen
        var openIt = function () { root.dataset.open = '1'; tgl.setAttribute('aria-expanded', 'true'); };
        var anchor = sec.querySelector('[id]');
        document.querySelectorAll('a[href^="#"]').forEach(function (a) {
          var id = a.getAttribute('href').slice(1);
          if (id && sec.querySelector('#' + CSS.escape(id))) a.addEventListener('click', openIt);
        });
        if (window.location.hash && sec.querySelector('#' + CSS.escape(window.location.hash.slice(1)))) openIt();
      }
      // Leere Blöcke ausblenden (nur Storefront)
      if (!designMode) {
        sec.querySelectorAll('.nw2__grid > *, .nw2__textcol > *').forEach(function (w) {
          if (w.classList && (w.classList.contains('nw2__textcol'))) return;
          // Elemente, die SELBST eine Rolle tragen (z. B. die Leerzustands-Zeile), nie per Inline-Style abschalten
          if (w.matches && w.matches('[data-nw-role]')) return;
          if (!w.querySelector('[data-nw-role]')) w.style.display = 'none';
        });
      }
      setupObserver(sec);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pdpDetails) return; window.__pdpDetails = true;
  // Fallback-Verdrahtung der Weiterlesen-Mechanik, falls die Kopf-Section nicht auf der Seite ist
  function wireClampLocal(root) {
    if (root.dataset.pdpWired) return; root.dataset.pdpWired = '1';
    var text = root.querySelector('.pdp-clamp__text'), more = root.querySelector('.pdp-clamp__more'), less = root.querySelector('.pdp-clamp__less');
    if (!text) return;
    function measure() { if (root.classList.contains('is-open')) return; root.classList.toggle('has-more', text.scrollHeight > text.clientHeight + 2); }
    function toggle() { if (!root.classList.contains('has-more') && !root.classList.contains('is-open')) return; root.classList.toggle('is-open'); if (!root.classList.contains('is-open')) measure(); }
    if (more) more.addEventListener('click', toggle); if (less) less.addEventListener('click', toggle);
    text.addEventListener('click', function () { if (root.classList.contains('has-more') || root.classList.contains('is-open')) toggle(); });
    measure(); window.addEventListener('resize', measure); root.__pdpMeasure = measure;
  }
  function tint(sec) {
    var grid = sec.querySelector('[data-pdpd-grid]'); if (!grid) return;
    var n = 0;
    Array.prototype.slice.call(grid.children).forEach(function (w) {
      var root = w.querySelector ? w.querySelector('[data-pdpd]') : null;
      if (!root) { w.style.display = 'none'; return; }
      w.style.display = '';
      if (root.dataset.ownBg !== '1') root.style.setProperty('--pdp-self-bg', 'var(--pdp-tint-' + ((n % 4) + 1) + ')');
      n++;
    });
    sec.querySelectorAll('.pdp-clamp').forEach(window.__pdpWireClamp || wireClampLocal);
    if (!grid.__obs) {
      var obs = new MutationObserver(function () { obs.disconnect(); try { tint(sec); } catch (e) {} if (grid.isConnected) obs.observe(grid, { childList: true }); });
      grid.__obs = obs; obs.observe(grid, { childList: true });
    }
  }
  // Zeilenzahl des Herkunft-/Hersteller-Textes an die Höhe der Nachbarblöcke angleichen
  function autoClamp(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (window.innerWidth < 750) {
      root.querySelectorAll('[data-autoclamp] .pdpko__t').forEach(function (c) { c.style.removeProperty('--pdp-lines'); });
      return;
    }
    // Zwei Durchgänge: Erst ALLE Textkarten auf die Mindestzeilen setzen, dann jede auffüllen.
    // In einem Durchgang würde sich die zweite Karte an der bereits aufgefüllten ersten orientieren,
    // und beide würden höher als der Steckbrief.
    var teile = [];
    root.querySelectorAll('[data-pdp-kombi][data-autoclamp]').forEach(function (block) {
      var panel = block.querySelector('[data-ko-panel]:not([hidden])');
      if (!panel) return;
      var clampEl = panel.querySelector('.pdpko__t');
      var textEl = clampEl && clampEl.querySelector('.pdp-clamp__text');
      if (!clampEl || !textEl || clampEl.classList.contains('is-open')) return;
      var lh = parseFloat(getComputedStyle(textEl).lineHeight);
      if (!lh || isNaN(lh)) return;
      var min = parseInt(block.dataset.autoclampMin || '4', 10);
      clampEl.style.setProperty('--pdp-lines', min);
      teile.push({ block: block, clampEl: clampEl, lh: lh, lines: min });
    });
    teile.forEach(function (x) {
      for (var i = 0; i < 5; i++) {
        var cs = getComputedStyle(x.block);
        var content = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
        var kids = Array.prototype.slice.call(x.block.children).filter(function (k) {
          return !k.hidden && getComputedStyle(k).display !== 'none';
        });
        var gap = parseFloat(cs.rowGap) || 0;
        content += gap * Math.max(0, kids.length - 1);
        kids.forEach(function (k) { content += k.getBoundingClientRect().height; });
        var slack = x.block.getBoundingClientRect().height - content;
        var extra = Math.floor((slack + 1) / x.lh);
        if (extra <= 0) break;
        x.lines += extra;
        x.clampEl.style.setProperty('--pdp-lines', x.lines);
      }
      if (x.clampEl.__pdpMeasure) x.clampEl.__pdpMeasure();
    });
  }

  // Steckbrief einklappen (nur Desktop): Ist er deutlich länger als die Nachbarkarten in derselben Reihe,
  // verschwinden markierte Zeilen von unten, aber nur so viele, dass er nicht kürzer wird als die
  // längste Nachbarkarte mit ganz ausgeklapptem Text. So bleibt dort nichts abgeschnitten.
  function boxContent(el) {
    var cs = getComputedStyle(el);
    var h = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var kids = Array.prototype.slice.call(el.children).filter(function (k) {
      return !k.hidden && getComputedStyle(k).display !== 'none';
    });
    h += (parseFloat(cs.rowGap) || 0) * Math.max(0, kids.length - 1);
    kids.forEach(function (k) {
      var ks = getComputedStyle(k);
      h += k.getBoundingClientRect().height + (parseFloat(ks.marginTop) || 0) + (parseFloat(ks.marginBottom) || 0);
    });
    return h;
  }
  function wireFold(sb) {
    if (sb.dataset.foldWired) return; sb.dataset.foldWired = '1';
    var btn = sb.querySelector('.pdpsb__more');
    if (btn) btn.addEventListener('click', function () {
      var open = !sb.classList.contains('is-open');
      sb.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (sb.hasAttribute('data-fold-hover') && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var tIn, tOut;
      sb.addEventListener('mouseenter', function () { clearTimeout(tOut); tIn = setTimeout(function () { sb.classList.add('is-hover'); }, 120); });
      sb.addEventListener('mouseleave', function () { clearTimeout(tIn); tOut = setTimeout(function () { sb.classList.remove('is-hover'); }, 180); });
    }
  }
  function fold(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.pdpd-steckbrief[data-fold]').forEach(function (sb) {
      wireFold(sb);
      var wraps = Array.prototype.slice.call(sb.querySelectorAll('.pdpsb__rows > *')).filter(function (w) {
        return w.querySelector('.sbz--fold');
      });
      wraps.forEach(function (w) { w.removeAttribute('data-folded'); });
      sb.classList.remove('is-folded');
      if (!wraps.length || window.innerWidth < 750) return;
      var grid = sb.closest('[data-pdpd-grid]');
      if (!grid) return;
      var col = sb;
      while (col.parentElement && col.parentElement !== grid) col = col.parentElement;
      var top = col.getBoundingClientRect().top, target = 0, n = 0;
      Array.prototype.slice.call(grid.children).forEach(function (c) {
        if (c === col || getComputedStyle(c).display === 'none') return;
        var box = c.querySelector('[data-pdpd]');
        if (!box || Math.abs(c.getBoundingClientRect().top - top) > 2) return;
        var h = boxContent(box);
        box.querySelectorAll('.pdp-clamp__text').forEach(function (t) {
          if (t.offsetParent !== null) h += Math.max(0, t.scrollHeight - t.clientHeight);
        });
        target = Math.max(target, h); n++;
      });
      if (!n || boxContent(sb) - target < 48) return;
      sb.classList.add('is-folded');
      var cur = boxContent(sb), any = false;
      for (var i = wraps.length - 1; i >= 0; i--) {
        var rh = wraps[i].getBoundingClientRect().height;
        if (cur - rh < target) break;
        wraps[i].setAttribute('data-folded', ''); cur -= rh; any = true;
      }
      if (!any) sb.classList.remove('is-folded');
    });
  }
  function layout(scope) { fold(scope); autoClamp(scope); }
  window.__pdpAutoClamp = layout;

  function run(scope) {
    var root = scope || document, list = [];
    if (root.classList && root.classList.contains('section-pdp-details')) list.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.section-pdp-details').forEach(function (x) { list.push(x); });
    list.forEach(tint);
    list.forEach(layout);
  }
  var _acT;
  window.addEventListener('resize', function () { clearTimeout(_acT); _acT = setTimeout(function () { layout(document); }, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(document); });
  window.addEventListener('load', function () { layout(document); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); }); else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sct = e.target.closest('.section-pdp-details'); if (sct) tint(sct);
    // Im Editor eine eingeklappte Zeile anwählen: Steckbrief aufklappen, damit man sie sieht
    var sb = e.target.closest('.pdpd-steckbrief.is-folded');
    if (sb) { sb.classList.add('is-open'); var b = sb.querySelector('.pdpsb__more'); if (b) b.setAttribute('aria-expanded', 'true'); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pdpHero) return;
  window.__pdpHero = true;

  function sortBlocks(sec) {
    var grid = sec.querySelector('[data-pdp-grid]'); if (!grid) return;
    var links = grid.querySelector('[data-pdp-links]');
    var info = grid.querySelector('[data-pdp-info]');
    if (!links || !info) return;
    var loose = Array.prototype.slice.call(grid.children).filter(function (c) { return c !== links && c !== info; });
    var rewired = false;
    loose.forEach(function (w) {
      var target = (w.querySelector && w.querySelector('[data-pdp-slot="links"]')) ? links : info;
      var node = w;
      // Bereits upgegradete Custom Elements (Horizon-Kaufform) würden beim Umhängen ihren Zustand verlieren -> frischer Klon
      if (w.querySelector && w.querySelector('product-form-component, quantity-selector-component')) {
        node = w.cloneNode(true);
        node.querySelectorAll('[data-kauf-wired],[data-wired],[data-pdp-wired],[data-collap-wired]').forEach(function (el) {
          delete el.dataset.kaufWired; delete el.dataset.wired; delete el.dataset.pdpWired; delete el.dataset.collapWired;
        });
        w.remove();
        rewired = true;
      }
      target.appendChild(node);
    });
    if (rewired) document.dispatchEvent(new CustomEvent('pdp:rewire', { detail: { scope: sec } }));
    // Kaufbox an den Spaltenboden: Dehn-Element davor (Wrapper-Margins sind gesperrt)
    var buyWrap = null;
    Array.prototype.slice.call(info.children).forEach(function (w) {
      if (w.querySelector && w.querySelector('[data-pdp-buy]')) buyWrap = w;
    });
    var stretch = info.querySelector(':scope > .pdp-stretch');
    if (buyWrap) {
      if (!stretch) { stretch = document.createElement('div'); stretch.className = 'pdp-stretch'; }
      if (stretch.nextElementSibling !== buyWrap) info.insertBefore(stretch, buyWrap);
    } else if (stretch) { stretch.remove(); }
  }

  function wireClamp(root) {
    if (root.dataset.pdpWired) return;
    root.dataset.pdpWired = '1';
    var text = root.querySelector('.pdp-clamp__text');
    var more = root.querySelector('.pdp-clamp__more');
    var less = root.querySelector('.pdp-clamp__less');
    if (!text) return;
    function measure() {
      if (root.classList.contains('is-open')) return;
      root.classList.toggle('has-more', text.scrollHeight > text.clientHeight + 2);
    }
    function toggle() {
      if (!root.classList.contains('has-more') && !root.classList.contains('is-open')) return;
      root.classList.toggle('is-open');
      if (!root.classList.contains('is-open')) measure();
    }
    if (more) more.addEventListener('click', toggle);
    if (less) less.addEventListener('click', toggle);
    text.addEventListener('click', function () { if (root.classList.contains('has-more') || root.classList.contains('is-open')) toggle(); });
    measure();
    window.addEventListener('resize', measure);
    root.__pdpMeasure = measure;
  }

  function wireThumbs(sec) {
    var wrap = sec.querySelector('[data-pdp-thumbs]'); if (!wrap || wrap.dataset.wired) return;
    wrap.dataset.wired = '1';
    var main = sec.querySelector('img.pdp-img');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp-thumb]'); if (!b || !main) return;
      main.src = b.dataset.src; if (b.dataset.srcset) main.srcset = b.dataset.srcset;
      wrap.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  }

  function process(sec) {
    sortBlocks(sec);
    sec.querySelectorAll('.pdp-clamp').forEach(wireClamp);
    wireThumbs(sec);
    var grid = sec.querySelector('[data-pdp-grid]');
    if (grid && !grid.__obs) {
      var obs = new MutationObserver(function () { obs.disconnect(); try { process(sec); } catch (e) {} if (grid.isConnected) obs.observe(grid, { childList: true }); });
      grid.__obs = obs; obs.observe(grid, { childList: true });
    }
  }
  window.__pdpProcess = process;
  window.__pdpWireClamp = wireClamp;

  function run(scope) {
    var root = scope || document, list = [];
    if (root.classList && root.classList.contains('section-pdp-hero')) list.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.section-pdp-hero').forEach(function (s) { list.push(s); });
    list.forEach(process);
    // Clamp-Blöcke auch außerhalb der Kopf-Section (Details) verdrahten
    if (root.querySelectorAll) root.querySelectorAll('.pdp-clamp').forEach(wireClamp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var s = e.target.closest('.section-pdp-hero'); if (s) process(s); });
  document.addEventListener('pdp:rewire', function (e) { var sc = e.detail && e.detail.scope; if (sc) { sc.querySelectorAll('.pdp-clamp').forEach(wireClamp); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-produkt-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActiveMarker(root, id) {
      root.querySelectorAll('.hs__marker.is-active, .hs__mcard.is-active').forEach(function (m) { m.classList.remove('is-active'); });
      root.querySelectorAll('[data-hs-open="' + id + '"]').forEach(function (m) { m.classList.add('is-active'); });
    }
    function closeRoot(root) {
      if (!root || root.classList.contains('hs--alwayson')) return;
      root.querySelectorAll('.hs__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      root.querySelectorAll('.hs__marker.is-active, .hs__mcard.is-active').forEach(function (m) { m.classList.remove('is-active'); });
      root.classList.remove('hs--open');
    }
    function openPanel(root, id) {
      var panel = document.getElementById(id);
      if (!panel || !root) return;
      root.querySelectorAll('.hs__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      panel.classList.add('is-open');
      root.classList.add('hs--open');
      setActiveMarker(root, id);
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-hs-open]');
      if (opener) {
        e.preventDefault();
        var root = opener.closest('[data-hs-root]');
        var id = opener.getAttribute('data-hs-open');
        var target = document.getElementById(id);
        var alwaysOn = root && root.classList.contains('hs--alwayson');
        if (target && target.classList.contains('is-open') && !alwaysOn) { closeRoot(root); return; }
        openPanel(root, id);
        return;
      }
      var navBtn = e.target.closest('[data-hs-nav]');
      if (navBtn) {
        var nroot = navBtn.closest('[data-hs-root]');
        if (!nroot) return;
        var panels = Array.prototype.slice.call(nroot.querySelectorAll('.hs__panel'));
        var current = nroot.querySelector('.hs__panel.is-open');
        var idx = panels.indexOf(current);
        if (idx < 0) return;
        var dir = navBtn.getAttribute('data-hs-nav') === 'next' ? 1 : -1;
        var next = panels[(idx + dir + panels.length) % panels.length];
        openPanel(nroot, next.id);
        return;
      }
      var closer = e.target.closest('[data-hs-close]');
      if (closer) { closeRoot(closer.closest('[data-hs-root]')); return; }
      var addBtn = e.target.closest('[data-bundle-add]');
      if (addBtn) { var hsRoot = addBtn.closest('[data-hs-root]'); if (hsRoot) closeRoot(hsRoot); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { document.querySelectorAll('[data-hs-root].hs--open').forEach(closeRoot); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-produkt-teaser"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (!customElements.get('pt-slider')) {
    class PTSlider extends HTMLElement {
      connectedCallback(){
        this.track = this.querySelector('[data-pt-track]');
        if(!this.track) return;
        this.prev = this.querySelector('[data-pt-prev]');
        this.next = this.querySelector('[data-pt-next]');
        this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({left:-this.step(), behavior:'smooth'}));
        this.next && this.next.addEventListener('click', () => this.track.scrollBy({left:this.step(), behavior:'smooth'}));
        this.track.addEventListener('scroll', () => this.updateNav(), {passive:true});
        window.addEventListener('resize', () => this.updateNav());
        this.initDrag();
        this.initAutoplay();
        this.updateNav();
      }
      step(){
        var t = this.track.querySelector('.pt__tile');
        var g = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
        return t ? (t.offsetWidth + g) : this.track.clientWidth * 0.8;
      }
      updateNav(){
        var t = this.track, max = t.scrollWidth - t.clientWidth - 2;
        if (this.prev) this.prev.toggleAttribute('disabled', t.scrollLeft <= 2);
        if (this.next) this.next.toggleAttribute('disabled', t.scrollLeft >= max);
      }
      initDrag(){
        var t = this.track, down=false, sx=0, sl=0, moved=false;
        t.addEventListener('pointerdown', function(e){ if(e.pointerType!=='mouse') return; down=true; moved=false; sx=e.clientX; sl=t.scrollLeft; t.classList.add('is-grabbing'); });
        window.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; t.scrollLeft = sl - dx; });
        window.addEventListener('pointerup', function(){ down=false; t.classList.remove('is-grabbing'); });
        t.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
      }
      initAutoplay(){
        var sec = parseFloat(this.dataset.autoplay || '0'); if(!sec) return;
        var self = this, timer = null;
        var go = function(){ var t=self.track, max=t.scrollWidth-t.clientWidth-2; if(t.scrollLeft>=max){ t.scrollTo({left:0,behavior:'smooth'}); } else { t.scrollBy({left:self.step(),behavior:'smooth'}); } };
        var start = function(){ stop(); timer = setInterval(go, sec*1000); };
        var stop = function(){ if(timer) clearInterval(timer); timer=null; };
        start();
        this.addEventListener('pointerenter', stop);
        this.addEventListener('pointerleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
      }
    }
    customElements.define('pt-slider', PTSlider);
  }

  if (!window.__ptCartBound) {
    window.__ptCartBound = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-pt-add]'); if(!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-pt-add'); if(!id) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      btn.classList.add('is-loading'); btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
      }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true}));
          var n = document.querySelector('cart-notification, cart-drawer');
          if (n && typeof n.open === 'function') n.open();
          btn.classList.remove('is-loading'); btn.classList.add('is-success');
          setTimeout(function(){ btn.classList.remove('is-success'); btn.disabled=false; }, 1400);
        }).catch(function(err){ btn.classList.remove('is-loading'); btn.disabled=false; alert('Warenkorb: ' + err.message); });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tab-galerie"] && !Shopify.designMode) return;
  try {
    
  if (!window.__tgTabsInit) {
    window.__tgTabsInit = true;
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tg-tab]');
      if (!tab) return;
      var root = tab.closest('.tg');
      if (!root) return;
      var key = tab.dataset.tgTab;
      root.querySelectorAll('[data-tg-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      root.querySelectorAll('[data-tg-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.tgPanel === key); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-buchung"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tb-book')) return;
  function eur(c){ return '€' + (c/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  customElements.define('tb-book', class extends HTMLElement {
    connectedCallback(){
      this.persons = 1;
      this.unit = parseInt(this.dataset.unit,10)||0;
      this.max = parseInt(this.dataset.max,10)||18;
      var self=this;
      this.querySelectorAll('[data-tb-inc]').forEach(function(b){ b.addEventListener('click',function(){ self.step(1); }); });
      this.querySelectorAll('[data-tb-dec]').forEach(function(b){ b.addEventListener('click',function(){ self.step(-1); }); });
      this.querySelectorAll('[data-tb-reserve]').forEach(function(b){ b.addEventListener('click',function(e){ self.reserve(e,b); }); });
    }
    step(d){
      this.persons = Math.min(this.max, Math.max(1, this.persons+d));
      var s=this;
      this.querySelectorAll('[data-tb-persons]').forEach(function(el){ el.textContent=s.persons; });
      this.querySelectorAll('[data-tb-personword]').forEach(function(el){ el.textContent = s.persons===1 ? (s.dataset.word1||'Person') : (s.dataset.wordn||'Personen'); });
      if(this.unit){ var t=this.querySelector('[data-tb-total]'); if(t) t.textContent=eur(this.unit*this.persons); }
    }
    reserve(e,btn){
      if(!this.dataset.variant) return;
      e.preventDefault();
      var self=this, root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      btn.classList.add('is-loading');
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:this.persons}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Fehler'); }); return r.json(); })
        .then(function(){ document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true})); var n=document.querySelector('cart-notification, cart-drawer'); if(n&&n.open) n.open(); btn.classList.remove('is-loading'); btn.classList.add('is-success'); setTimeout(function(){ btn.classList.remove('is-success'); },1500); })
        .catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tct-cta')) return;
  customElements.define('tct-cta', class extends HTMLElement {
    connectedCallback(){
      var self=this;
      this.querySelectorAll('[data-tct-reserve]').forEach(function(b){ b.addEventListener('click', function(e){ self.reserve(e,b); }); });
    }
    reserve(e,btn){
      if(!this.dataset.variant) return;
      e.preventDefault();
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      btn.classList.add('is-loading');
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Fehler'); }); return r.json(); })
        .then(function(){ document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true})); var n=document.querySelector('cart-notification, cart-drawer'); if(n&&n.open) n.open(); btn.classList.remove('is-loading'); btn.classList.add('is-success'); setTimeout(function(){ btn.classList.remove('is-success'); },1500); })
        .catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tfq-acc')) return;
  customElements.define('tfq-acc', class extends HTMLElement {
    connectedCallback(){
      var single = this.dataset.single === '1';
      var group = this.querySelector('[data-tfq]'); if(!group) return;
      group.addEventListener('click', function(e){
        var tog = e.target.closest('[data-tfq-toggle]'); if(!tog) return;
        var item = tog.closest('[data-tfq-item]');
        var open = item.classList.contains('is-open');
        if(single){ group.querySelectorAll('[data-tfq-item]').forEach(function(it){ it.classList.remove('is-open'); var s=it.querySelector('.tfq__sign'); if(s) s.textContent='+'; }); }
        if(open && !single){ item.classList.remove('is-open'); var s=item.querySelector('.tfq__sign'); if(s) s.textContent='+'; }
        else if(!open){ item.classList.add('is-open'); var s2=item.querySelector('.tfq__sign'); if(s2) s2.textContent='–'; }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-katalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tkKatalog) return;
  window.__tkKatalog = true;

  function init(root) {
    if (root.dataset.wired) return;
    root.dataset.wired = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tk-card]'));
    var catBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tk-cat]'));
    var monBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tk-mon]'));
    var grid = root.querySelector('[data-tk-grid]');
    var empty = root.querySelector('[data-tk-empty]');
    var emptyH = root.querySelector('[data-tk-empty-h]');
    var reset = root.querySelector('[data-tk-reset]');
    var count = root.querySelector('[data-tk-count]');
    var st = { cat: 'alle', mon: 'alle' };
    if (!cards.length) return;

    function match(c, cat, mon) {
      return (cat === 'alle' || (c.dataset.cats || '').indexOf('|' + cat + '|') >= 0) && (mon === 'alle' || c.dataset.month === mon);
    }
    function update() {
      // Monate nur zeigen, wenn es dazu in der gewählten Art Termine gibt
      monBtns.forEach(function (b) {
        var m = b.dataset.tkMon;
        b.hidden = m !== 'alle' && !cards.some(function (c) { return match(c, st.cat, m); });
      });
      if (st.mon !== 'alle' && !cards.some(function (c) { return match(c, st.cat, st.mon); })) st.mon = 'alle';
      var n = 0;
      cards.forEach(function (c) { var ok = match(c, st.cat, st.mon); c.hidden = !ok; if (ok) n++; });
      catBtns.forEach(function (b) { b.classList.toggle('is-on', b.dataset.tkCat === st.cat); b.setAttribute('aria-pressed', b.dataset.tkCat === st.cat ? 'true' : 'false'); });
      monBtns.forEach(function (b) { b.classList.toggle('is-on', b.dataset.tkMon === st.mon); b.setAttribute('aria-pressed', b.dataset.tkMon === st.mon ? 'true' : 'false'); });
      var filtered = st.cat !== 'alle' || st.mon !== 'alle';
      if (count) {
        count.hidden = n === 0;
        count.textContent = n === 1 ? (root.dataset.countOne || '1 Tasting') : (root.dataset.countMany || '[ANZAHL] Tastings').replace('[ANZAHL]', n);
      }
      if (grid) grid.hidden = n === 0;
      if (empty) empty.hidden = n > 0;
      if (emptyH) emptyH.textContent = filtered ? emptyH.dataset.filter : emptyH.dataset.none;
      if (reset) reset.hidden = !filtered;
    }
    // Erneuter Klick auf den aktiven Filter wählt ihn wieder ab (zurück zu „Alle“)
    catBtns.forEach(function (b) { b.addEventListener('click', function () { var k = b.dataset.tkCat; st.cat = (st.cat === k) ? 'alle' : k; update(); }); });
    monBtns.forEach(function (b) { b.addEventListener('click', function () { var k = b.dataset.tkMon; st.mon = (st.mon === k) ? 'alle' : k; update(); }); });
    if (reset) reset.addEventListener('click', function () { st.cat = 'alle'; st.mon = 'alle'; update(); });
    update();
  }

  function run(scope) { (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-tk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-seite"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('ts-page')) return;
  function eur(cents){
    var v = (cents/100).toFixed(2).replace('.', ',');
    return '€' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  customElements.define('ts-page', class extends HTMLElement {
    connectedCallback(){
      // counter
      this.persons = 1;
      this.unit = parseInt(this.dataset.unit, 10) || 0;
      this.max = parseInt(this.dataset.max, 10) || 18;
      var self = this;
      this.querySelectorAll('[data-ts-inc]').forEach(function(b){ b.addEventListener('click', function(){ self.step(1); }); });
      this.querySelectorAll('[data-ts-dec]').forEach(function(b){ b.addEventListener('click', function(){ self.step(-1); }); });
      // faq (accordion, eine offen)
      this.querySelectorAll('[data-ts-faq]').forEach(function(group){
        group.addEventListener('click', function(e){
          var tog = e.target.closest('[data-ts-faq-toggle]'); if(!tog) return;
          var item = tog.closest('[data-ts-faq-item]');
          var open = item.classList.contains('is-open');
          group.querySelectorAll('[data-ts-faq-item]').forEach(function(it){ it.classList.remove('is-open'); var s=it.querySelector('.ts__faq-sign'); if(s) s.textContent='+'; });
          if(!open){ item.classList.add('is-open'); var s=item.querySelector('.ts__faq-sign'); if(s) s.textContent='–'; }
        });
      });
      // reserve
      this.querySelectorAll('[data-ts-reserve]').forEach(function(btn){
        btn.addEventListener('click', function(e){ self.reserve(e, btn); });
      });
    }
    step(dir){
      this.persons = Math.min(this.max, Math.max(1, this.persons + dir));
      var self = this;
      this.querySelectorAll('[data-ts-persons]').forEach(function(el){ el.textContent = self.persons; });
      this.querySelectorAll('[data-ts-personword]').forEach(function(el){ el.textContent = self.persons === 1 ? (self.dataset.word1||'Person') : (self.dataset.wordn||'Personen'); });
      if(this.unit){ var t=this.querySelector('[data-ts-total]'); if(t) t.textContent = eur(this.unit * this.persons); }
    }
    reserve(e, btn){
      if(!this.dataset.variant){ return; } // kein Produkt → folge href
      e.preventDefault();
      var self = this, id = this.dataset.variant;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      btn.classList.add('is-loading');
      fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id:Number(id), quantity:self.persons }] }) })
        .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
          var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
          btn.classList.remove('is-loading'); btn.classList.add('is-success');
          setTimeout(function(){ btn.classList.remove('is-success'); }, 1500);
        }).catch(function(err){ btn.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tasting-uebersicht"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('tg-grid')) return;
  customElements.define('tg-grid', class extends HTMLElement {
    connectedCallback(){
      this.grid = this.querySelector('[data-tg-grid]');
      if(!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('.tg__card'));
      this.chips = this.querySelector('[data-tg-chips]');
      this.countEl = this.querySelector('[data-tg-count]');
      this.emptyEl = this.querySelector('[data-tg-empty]');

      if (this.dataset.sort === '1'){
        var ordered = this.cards.slice().sort(function(a,b){
          var ta = parseInt(a.dataset.ts,10); var tb = parseInt(b.dataset.ts,10);
          if(isNaN(ta)) ta = Infinity; if(isNaN(tb)) tb = Infinity;
          return ta - tb;
        });
        ordered.forEach(function(c){ this.grid.appendChild(c); }, this);
        this.cards = ordered;
      }

      if (this.chips){
        var self = this;
        this.chips.addEventListener('click', function(e){
          var chip = e.target.closest('[data-cat]'); if(!chip) return;
          self.chips.querySelectorAll('.tg__chip').forEach(function(c){ c.classList.toggle('is-active', c === chip); });
          self.filter(chip.dataset.cat);
        });
      }
    }
    filter(cat){
      var n = 0;
      this.cards.forEach(function(card){
        var cats = card.dataset.cats || '';
        var show = cat === '__all' || cats.indexOf(' ' + cat + ' ') > -1;
        card.style.display = show ? '' : 'none';
        if(show) n++;
      });
      if(this.countEl) this.countEl.textContent = n;
      if(this.emptyEl) this.emptyEl.hidden = n > 0;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-wein-der-woche"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wdwCartBound) return;
  window.__wdwCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wdw-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wdw-add'); if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading'); b.disabled = true;
    fetch(root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
    }).then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || 'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated', {bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer');
        if (n && typeof n.open === 'function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); b.disabled=false; }, 1400);
      }).catch(function(err){ b.classList.remove('is-loading'); b.disabled=false; alert('Warenkorb: ' + err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-weinkatalog-magazin"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wkCartBound) return;
  window.__wkCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wk-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wk-add'); var qty = parseInt(b.getAttribute('data-wk-qty'),10) || 1;
    if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:qty }] }) })
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); }, 1300);
      }).catch(function(err){ b.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-weinkatalog"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wkCartBound) return;
  window.__wkCartBound = true;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-wk-add]'); if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wk-add'); var qty = parseInt(b.getAttribute('data-wk-qty'),10) || 1;
    if(!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    b.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id:Number(id), quantity:qty }] }) })
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||j.message||'Fehler'); }); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
        var n = document.querySelector('cart-notification, cart-drawer'); if(n && typeof n.open==='function') n.open();
        b.classList.remove('is-loading'); b.classList.add('is-success');
        setTimeout(function(){ b.classList.remove('is-success'); }, 1300);
      }).catch(function(err){ b.classList.remove('is-loading'); alert('Warenkorb: '+err.message); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
